(ns dashboard.components.questionnaire.questionnaire-status)

(defn questionnaire-status
  [{:keys [current-status on-change]}]
  [:div.level
   [:span.mr-1 "Status:"]
   [:div.select.is-small.mr-1
    [:select {:value (or current-status "")
              :on-change #(on-change (.. % -target -value))
              :title "Change questionnaire status"}
     [:option {:label "To-do" :value nil}]
     (map (fn [{:keys [value label]}]
            ^{:key value}
            [:option {:value value} label])
          [{:label "In progress",
            :value "in-progress"}
           {:label "Approved",
            :value "approved"}])]]])
